var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('div',[_c('span',{staticClass:"text-red-600"},[_vm._v(_vm._s(_vm.value?.minimum)+"万人")]),_vm._v(" - "),_c('span',{staticClass:"text-red-600"},[_vm._v(" "+_vm._s(_vm.value?.maximum)+"万人")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }